module.exports = __webpack_public_path__ + "static/img/open-icon.906adc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/open-icon.png
// module id = 0l4X
// module chunks = 213